window.postSmtpDashboard = function() {
    try {
        window.Vue = require('vue');
        window.axios = require('axios');
        window.axios = window.axios.create({
            baseURL: postSmtpNewDashboard.json_url,
            headers: {
                'X-WP-Nonce': postSmtpNewDashboard.nonce,
                'Content-Type': 'application/json',
            }
        });

        require('./vue')
    } catch (e) {

    }
};

window.postSmtpEmailLogs = function() {
    var window_location_href = window.location.href
    window_location_href = new URLSearchParams( window_location_href )

    if ( 'failed' === window_location_href.get( 'status' ) ) {
        let interval_id = setInterval( function() {

            let el = document.querySelectorAll( 'button[data-status="failed"]' );
            if ( el.length ) {
                el[0].click();
                clearInterval( interval_id );
            }
        }, 100 );
    }
}

if ( 'toplevel_page_postman' === postSmtpNewDashboard.page_hook ) {
    window.postSmtpDashboard();
} else if ( 'post-smtp_page_postman_email_log' === postSmtpNewDashboard.page_hook ) {
    window.postSmtpEmailLogs();
}
